// removed by extract-text-webpack-plugin
module.exports = {"container":"Intro__container___2n3Mi","container-center":"Intro__container-center___2yxtr Intro__container___2n3Mi","image":"Intro__image___3nJcx","body":"Intro__body___-Bmav _typography__p___312so _typography__content___3raTl","footer":"Intro__footer___2vZgD","header":"Intro__header___11lBs _typography__h1___bhOGX _typography__headers___eO5yD"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/Intro.scss
// module id = 546
// module chunks = 0